///<reference path="../require.d.ts"/>

import {SearchResult} from "../models/SearchResult";
import {stringify} from "qs";

interface MapParams {
    lat: number;
    lng: number;
    zoom: number;
    icon: string;
    withRooms: boolean;
}

interface MapRoom {
    id: number;
    name: string;
    lat: number;
    lng: number;
}

class MapController {

    static $inject = ["$element", "$timeout", "$http"];

    map: google.maps.Map;
    params: MapParams;

    constructor(
        private $element: angular.IAugmentedJQuery,
        private $timeout: angular.ITimeoutService,
        private $http: angular.IHttpService
    ) {
        this.params = $element.data() as MapParams;
        this.initMap();
    }

    private initMap(): void {
        if (!gmapInitialized) {
            this.$timeout(() => this.initMap(), 100);
            return;
        }
        const center = new google.maps.LatLng(this.params.lat, this.params.lng);
        this.map = new google.maps.Map(this.$element.get(0), {
            center: center,
            zoom: this.params.zoom,
            scrollwheel: false,
        });
        if (this.params.withRooms) {
            this.map.addListener("tilesloaded", () => this.loadRooms());
        } else {
            new google.maps.Marker({map: this.map, icon: this.params.icon, position: center});
        }
    }

    private loadRooms(): void {
        const b = this.map.getBounds();
        const ne = b.getNorthEast();
        const sw = b.getSouthWest();
        const params = {
            ne: {lat: ne.lat(), lng: ne.lng()},
            sw: {lat: sw.lat(), lng: sw.lng()},
            limit: 200,
        };
        const query = stringify(params);
        this.$http.get<SearchResult<MapRoom>>(`${apiRoot}/rooms?${query}`).success((result) => {
            result.items.forEach((r) => {
                this.showRoom(r);
            });
        });
    }

    private showRoom(r: MapRoom): void {
        const pos = new google.maps.LatLng(r.lat, r.lng);
        const k = new google.maps.Marker({
            map: this.map,
            icon: this.params.icon,
            position: pos,
            title: r.name,
        });
        k.addListener('click', () => {
            if (/\/preview\/\d+$/.test(location.pathname)) {
                console.info(r.id);
            } else {
                location.href = `/rooms/${r.id}.html`;
            }
        });
    };

}
angular.module('hp').controller('MapController', MapController);



// WEBPACK FOOTER //
// ./controllers/MapController.ts